export default "__VITE_ASSET__DJZBa5ly__"